// extracted by mini-css-extract-plugin
module.exports = {"container":"OneRecentRequestLinkButton_container__eXLMC","icon":"OneRecentRequestLinkButton_icon__GxRzN"};